import {
  GET_PARTNER_CONFIG,
  SET_COLORS,
  SET_FUNNEL_STEP,
  SET_PARTNER_CONFIG,
  SET_PARTNER_EXTERNAL_ID,
  SET_PARTNER_ID,
  SET_PRIMARY_COLOR,
  SET_SEARCH_URL,
  SET_SECONDARY_COLOR,
} from './constants';

/**
 * @description Action to set the current Funnel step
 * @param {string} step
 * @return {{type: string, step: string}}
 */
export function setFunnelStepAction(step) {
  return {
    type: SET_FUNNEL_STEP,
    step,
  };
}

/**
 * @description Action to set the search url
 * @param {string} url
 * @return {{type: string, url: string}}
 */
export function setSearchUrlAction(url) {
  return {
    type: SET_SEARCH_URL,
    url,
  };
}

/**
 * @description Action to set the partner Id
 * @param {string} partnerId
 * @return {{type: string, partnerId: string}}
 */
export function setPartnerIdAction(partnerId) {
  return {
    type: SET_PARTNER_ID,
    partnerId,
  };
}

/**
 * @description Action to set the partner external Id, used for order tracking
 * @param {string} partnerExternalId
 * @return {{type: string, partnerExternalId: string}}
 */
export function setPartnerExternalIdAction(partnerExternalId) {
  return {
    type: SET_PARTNER_EXTERNAL_ID,
    partnerExternalId,
  };
}

/**
 * @description Action to set the theme primary color
 * @param {string} color - Formatted #22E4AB
 * @return {{type: string, color: object}}
 */
export function setPrimaryColorAction(color) {
  return {
    type: SET_PRIMARY_COLOR,
    color,
  };
}

/**
 * @description Action to set the theme secondary color
 * @param {string} color - Formatted #22E4AB
 * @return {{type: string, color: object}}
 */
export function setSecondaryColorAction(color) {
  return {
    type: SET_SECONDARY_COLOR,
    color,
  };
}

/**
 * @description Action to set the whole theme
 * @param {object} theme
 * @return {{type: string, theme: object}}
 */
export function setThemeAction(theme) {
  return {
    type: SET_COLORS,
    theme,
  };
}

/**
 * @description Action to fetch the partner config from api
 * @param {string} partnerId
 * @return {{partnerId: string, type: string}}
 */
export function getPartnerConfigAction(partnerId) {
  return {
    type: GET_PARTNER_CONFIG,
    partnerId,
  };
}

/**
 * @description Action to set the partner config retrieved from api
 * @param {object} config
 * @return {{type: string, config: object}}
 */
export function setPartnerConfigAction(config) {
  return {
    type: SET_PARTNER_CONFIG,
    config,
  };
}
